import React, { useEffect, useMemo, useRef, useState } from 'react';
import './Checkin.css'
import { Helmet } from 'react-helmet-async';
import { DateTime } from 'luxon'
// @mui
import { Container, Stack, Typography, Paper, Box, Button, Grid, Alert, AlertTitle } from '@mui/material';

// components
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';
import Tick from '@pqina/flip';
import YoutubePlayer from '../components/videoplayer/Youtube';
import HTTPService from '../services/httpservice';
import Iconify from '../components/iconify/Iconify';
import TrackInfo from '../sections/@dashboard/info/TrackInfo';
import QueueInfo from '../sections/@dashboard/info/QueueInfo';
import CourseInfo from '../sections/@dashboard/info/CourseInfo';
import QueuesService from '../services/queues.service';
import SpotifyService from '../services/spotify.service';
import { NGROK_REDIRECT_URL, consideredDensityHours, generateRandomString, groupArrayBy, isLocalhost, maxCapacity, statParams } from '../App';
import CheckinsService from '../services/checkins.service';
import InfoPaper from '../sections/@dashboard/info/InfoPaper';
import { CHECKINTYPE, DensityWeight, densityColors, getTempColors } from '../constants';
import UserService from '../services/user.service';
import AppTreemap from '../sections/@dashboard/app/AppTreemap';
import TempInfo from '../models/tempinfo';

export default function InfoTainment() {

  const currentDay = DateTime.local().startOf('day')

  const now = useRef()
  now.current = DateTime.local().startOf('hour')
  // console.log('currentDay', currentDay);

  const encodedQR = `${DateTime.local().plus({ minute: 30 }).startOf('hour').valueOf().toString()}`
  // console.log('currentDay.valueOf().toString()', currentDay.valueOf().toString());

  const [timestamp, setTimestamp] = useState(currentDay);
  // const [dayHours, loadingDayHours, errorDayHours] = useCollection(QueuesService.getAllDayQueues(timestamp));
  const [offsetHour, setOffsetHour] = useState(0);
  const [allCheckins, loadingCheckins, errorQueues] = useCollection(CheckinsService.getCountOfDay(timestamp.valueOf().toString()))
  const [currentDensity, loadingCurrentDensity, errorGetCurrentDensity] = useCollection(CheckinsService.getCountAfterHour(now.current.minus({ hour: consideredDensityHours }).valueOf().toString()));
  const [coming, loadingComing, errorGetComing] = useCollection(QueuesService.getCountAfterHour(now.current.valueOf().toString()));
  const [messageOfTheDay, loadingMessage, errorGetMessage] = useDocument(CheckinsService.getMessageOfDay(timestamp.valueOf().toString()))
  const [spotifyToken, loadingToken, errorGetTOken] = useDocument(CheckinsService.getSpotifyAuthToken())
  // const [hourQRValue, setHourQRValue] = useState(encodedQR);
  const [densityWeight, setDensityWeight] = useState(Array(consideredDensityHours + 1).fill(0).map((_, hour) => now.current.minus({ hour }).valueOf()).reduce((o, key, index) => Object.assign(o, { [key]: DensityWeight[index] }), {}));
  const [users, loadingUsers, errorGetUsers] = useCollection(UserService.getRegisteredCheckedInUsers(now.current.minus({ hour: consideredDensityHours }).valueOf().toString()))
  const [gymOpen, loadingGymOpen, errorLoadingGymOpen] = useDocument(CheckinsService.gymOpenStatus)
  const [currentTempInfo, loadingCurrentTempInfo, errorLoadingCurrentTempInfo] = useCollection(CheckinsService.tempInfo)


  const [token, setToken] = useState('');
  const [track, setTrack] = useState({});
  const [queue, setQueue] = useState({});
  const [queues, setQueues] = useState([]);
  const [newTrackCountdown, setnewTrackCountdown] = useState(100);
  const [lyrics, setLyrics] = useState('');
  const newTrackTimer = useRef()
  const [videoSrc, setVideoSrc] = useState(null);
  // { url: 'https://youtu.be/Vu7cNuvLPb4?si=wnhfGCqHEttj2j82&', id: 'Vu7cNuvLPb4', startTime: new Date().valueOf() }
  const getTempTimer = useRef(null)

  const totalRef = useRef()
  const totalInstance = useRef()

  const totalDayCheckins = useMemo(() => {

    if (loadingCheckins || !allCheckins || allCheckins.empty) return 0
    // console.log('allCheckins', allCheckins.docs);
    return allCheckins.docs.reduce((p, h) => h.data().count + p, 0)
  }, [allCheckins, loadingCheckins])

  const totalDensity = useMemo(() => {

    // console.log('loadingCurrentDensity', loadingCurrentDensity);
    if (loadingCurrentDensity || !currentDensity || currentDensity.empty) return 0
    // console.log('currentDensity', currentDensity.docs);

    return currentDensity.docs.reduce((p, h) => Math.floor(h.data().count * (densityWeight[h.id] || 1)) + p, 0)

  }, [currentDensity, densityWeight, loadingCurrentDensity])

  const totalComing = useMemo(() => {

    if (loadingComing) return 0

    const totalQueuedCheckins = currentDensity && !currentDensity.empty ? currentDensity.docs.reduce((p, h) => {
      if (h.id < now.current.valueOf().toString()) return p
      return (h.data()[CHECKINTYPE.queued.name] || 0) + p
    }, 0) : 0;


    const audio = new Audio("/audios/swoosh-sound-effect-for-fight-scenes-or-transitions-2-149890.mp3")

    const start = () => {
      audio.play()
    }

    start()

    return Math.max(0, coming && !coming.empty ? coming.docs.reduce((p, h) => h.data().count + p, 0) - totalQueuedCheckins : 0)

  }, [coming, currentDensity, loadingComing])
  
  useEffect(() => {
    
    console.log('====================================');
    console.log(videoSrc);
    console.log('====================================');
    
  }, [videoSrc]);

  const videoPlayer = useMemo(() => {
    if (!videoSrc) return <></>
    return <Paper sx={{ bgcolor: "#b12be2", p: 2, maxHeight: "53.5vh", borderRadius: 4 }}>
      <YoutubePlayer videoSrc={videoSrc} setVideoSrc={setVideoSrc} startTime={videoSrc.startTime} />
    </Paper>
    
  }, [videoSrc])

  const info = useMemo(() => {

    if (loadingMessage) return <></>
    if (!messageOfTheDay || !messageOfTheDay.exists()) return <></>
    if (!messageOfTheDay.data().info) return <></>
    return <Paper sx={{ bgcolor: 'brown', p: 2, mt: 2 }}>
      <Typography variant="h4" sx={{ color: 'text.primary', m: 1, width: '100%' }}>
        {`INFO: ${messageOfTheDay.data().info}`}
      </Typography>
    </Paper>

  }, [loadingMessage, messageOfTheDay])

  const tempInfo = useMemo(() => {
    if (loadingCurrentTempInfo || !currentTempInfo || currentTempInfo.empty) return {}
    console.log('currentTempInfo', currentTempInfo.docs.length);
    const info = currentTempInfo.docs[0]
    console.log('info.data()', info.data());
    return info.data()

  }, [currentTempInfo, loadingCurrentTempInfo])

  const tempInfoUi = useMemo(() => {

    console.log('tempInfo', tempInfo);

    if (loadingCurrentTempInfo) return <></>
    // return {gymOpen.exists && gymOpen.data() && gymOpen.data().status === 'open' && }
    if (!currentTempInfo || currentTempInfo.empty) {
      return <></>
    }
    if (!tempInfo) return <></>
    const temperatureInfo = new TempInfo(tempInfo)
    return <Stack direction={'column'} spacing={1} >
      <Paper elevation={2} sx={{ p: 1, bgcolor: getTempColors(temperatureInfo.getUnifiedTemperature()) }}>
        <Typography variant="p" gutterBottom>
          อุณหภูมิห้อง
        </Typography>
        <Typography variant="h3" gutterBottom>
          {temperatureInfo.getTemperature()}
        </Typography>
      </Paper>
      <Typography gutterBottom variant="p">
        ความชื้น
      </Typography>
      <Typography gutterBottom variant="h4">
        {temperatureInfo.getHumidity()}
      </Typography>

    </Stack>

  }, [currentTempInfo, loadingCurrentTempInfo, tempInfo])

  const trackinfo = useMemo(() => {
    if (track && track.item) return (<TrackInfo
      track={track.item}
      queue={queue}
      queues={queues}
      start={track.progress_ms}
      duration={track.item.duration_ms}
      lyrics={lyrics}
      setnewTrackCountdown={setnewTrackCountdown} />)

    return (<Iconify icon="logos:spotify-icon" sx={{ width: '24vh', height: '24vh' }} />)


  }, [lyrics, queue, queues, track])

  const queueinfo = useMemo(() => {

    if (queue && queue.name) return (<QueueInfo track={queue} />)

    return (<Iconify icon="logos:spotify-icon" sx={{ width: '12vh', height: '12vh' }} />)


  }, [queue])

  // const trackinfo = useMemo(() => {

  //   if (token) {
  //     console.log('token', token);
  //     const sps = new SpotifyService()
  //     return sps.getPlayingTrack(token).then(r => r)
  //   }
  //   return <Paper sx={{ bgcolor:'lightgreen', m:1, p:1}}>TRACK INFO here</Paper>
  // }, [token])

  useEffect(() => {

    if (token && newTrackCountdown >= 0) {
      // console.log('token', token);

      if (newTrackTimer.current) clearTimeout(newTrackTimer.current)

      newTrackTimer.current = setTimeout(() => {

        const sps = new SpotifyService()
        // console.log('getting song info');
        sps.getPlayingTrack(token).then(async song => {

          // setTrackinfo(JSON.stringify(r))
          if (song && song.item) {
            setTrack(song)

            // console.log('song id', song);
            // const httpservice = new HTTPService()
            // await httpservice.getTrackLyrics(song.item.id)
            // .then(l => {
            //   // console.log('l', l);
            //   setLyrics(l)
            //   // setLyrics(l.reduce((p, c) => ({
            //   //   ...p,
            //   //   [c.startTimeMs]: c.words
            //   // }),{}))
            // })

            if (song.progress_ms && song.item.duration_ms) {
              setnewTrackCountdown(song.item.duration_ms - song.progress_ms - 5000)
            }



            // if (song.item.id) {
            //   const ds = new DataService()
            //   ds.getSpotifyCanvas(token, song.item.id, song.item.uri)
            //   .then(r => console.log(r.text()))
            //   .catch(e => console.log(e))
            // }

          } else {
            setnewTrackCountdown(-1)
          }

        })


        sps.getUserQueue(token).then(async song => {

          // setTrackinfo(JSON.stringify(r))
          if (song && song.queue && song.queue.length) {

            setQueue(song.queue[0])
            setQueues(song.queue)

          } else {
            setQueue({})
          }
        }
        )

      }, newTrackCountdown);
    }

    return (() => {
      if (newTrackTimer.current) clearTimeout(newTrackTimer.current)
    })

  }, [newTrackCountdown, token]);

  const unitsStat = useMemo(() => {

    if (users && users.docs.length) {

      return {
        ...statParams.unit,
        data: groupArrayBy(users.docs.filter(u => u.data().type).map(d => ({ ...d.data(), unit: d.data().unit.abbr || d.data().unit })), 'unit')
      }
    }
    return statParams.unit
  }, [users])

  // useEffect(() => {

  //   console.log(unitsStat);

  // }, [unitsStat])



  useEffect(() => {

    // async function getToken() {
    //   const ds = new DataService()
    //   const response = await ds.spotifyToken() // fetch('/auth/token');
    //   const accessToken = await response.access_token;
    //   if (accessToken) setToken(accessToken);
    // }

    // getToken();
    if (spotifyToken && spotifyToken.exists()) {
      setToken(spotifyToken.data().token)
      setnewTrackCountdown(1000)
    };

  }, [spotifyToken]);

  useEffect(() => {
    if (!totalInstance.current) return
    totalInstance.current.value = totalDayCheckins
  }, [totalDayCheckins]);

  useEffect(() => {
    if (!totalInstance.current) {
      totalInstance.current = Tick.DOM.create(totalRef.current, {
        value: totalDayCheckins
      }
      )
    }
  }, [totalDayCheckins]);

  const userstreemap = useMemo(() => (<AppTreemap
    title={'จำนวนผู้ใช้ในรอบแยกตามสังกัด'}
    chartData={unitsStat.data
      ? Object.entries(unitsStat.data).map(([label, items]) => ({ label, value: items.length }))
      : []}
  />), [unitsStat])

  useEffect(() => {

    const now = DateTime.local()
    // window.alert(now.current.set({ second: Math.ceil(now.current.second / 5)* 5}).diffNow().milliseconds)
    setTimeout(() => {
      // const encodedQR = `${DateTime.local().plus({ minute: 30}).startOf('hour').valueOf().toString()}`
      // setHourQRValue(encodedQR)
      // window.alert('changing qr now')
      setInterval(() => {
        // const encodedQR = `${DateTime.local().plus({ minute: 30}).startOf('hour').valueOf().toString()}`
        if (!currentDay.hasSame(DateTime.local(), 'day')) {
          window.location.reload()
        }
        // setHourQRValue(encodedQR)
        // window.alert('changing qr now')
      }, 30 * 60 * 1000);

    }, now.current ? now.current.endOf('hour').diffNow().milliseconds : 1000); // set({ minute: Math.ceil(now.current.minute / 10)* 10})); // .set({ minute: Math.ceil(now.current.second / 5) * 5}).diffNow().milliseconds); // .endOf('hour').diffNow().milliseconds); // set({ minute: Math.ceil(now.current.minute / 10)* 10})); // .
    // return  timer.
  }, [currentDay]);

  const SpotifyLogin = () => (<Button className="btn-spotify" color='success' onClick={async () => {

    const scope = "streaming user-read-email user-read-private user-read-playback-state"

    const state = generateRandomString(16);

    const authQueryParameters = new URLSearchParams({
      response_type: "code",
      client_id: '70d425d967b841e4947bf0da068f34d8',
      scope,
      redirect_uri: isLocalhost
        ? `${NGROK_REDIRECT_URL}/flexitarmstrong/us-central1/api/auth/callback`
        : "https://us-central1-flexitarmstrong.cloudfunctions.net/api/auth/callback",
      state
    })

    console.log(`https://accounts.spotify.com/authorize/?${authQueryParameters.toString()}`);
    window.open(`https://accounts.spotify.com/authorize/?${authQueryParameters.toString()}`);


  }}>
    <Iconify icon="logos:spotify-icon" sx={{ width: '24vh', height: '24vh' }} />
  </Button>
  )

  // href="/auth/login"
  useEffect(() => {

    now.current = DateTime.local().startOf('hour')
    const startHour = now.current.plus({ hour: offsetHour })
    const prev2Hours = startHour.minus({ hour: 1 })
    // setDisplayHours([prevHour, nextHour, next2Hours])
    setDensityWeight(Array(consideredDensityHours + 1).fill(0).map((_, hour) => now.current.minus({ hour }).valueOf()).reduce((o, key, index) => Object.assign(o, { [key]: DensityWeight[index] }), {}))

    setTimeout(() => {
      setInterval(() => {
        now.current = DateTime.local().startOf('hour')
        if ([0, 30].includes(now.current.minute)) {

          // console.log('updating time');
          setOffsetHour(0)
          const prev2Hours = now.current.minus({ hour: 1 })
          // setDisplayHours([prev2Hours, prevHour, nextHour, next2Hours])
          setDensityWeight(Array(consideredDensityHours + 1).fill(0).map((_, hour) => now.current.minus({ hour }).valueOf()).reduce((o, key, index) => Object.assign(o, { [key]: DensityWeight[index] }), {}))
        }
        if (!now.current.hasSame(timestamp, 'day')) setTimestamp(now.current.startOf('day'))
      }, 60000);
    }, now.current.startOf('minute').plus({ minute: 1 }).valueOf() - now.current.valueOf());


    // setTimeout(() => {
    //    setInterval(() => {
    //       const now = DateTime.local()
    //       const prevHour = now.current.minus({minute: 30}).startOf('hour')
    //       const nextHour = now.current.plus({ minute: 30 }).startOf('hour')
    //       setDisplayHours([prevHour, nextHour])
    //     }, 1 * 60 * 1000);
    // }, Duration.fromMillis(nextHour.valueOf() - now.current.valueOf()).milliseconds);

  }, [offsetHour, timestamp]) // DateTime.local().startOf('hour').valueOf().toString()

  const denseColor = Math.ceil((densityColors.length - 1) * totalDensity / maxCapacity)
  const queueColor = Math.ceil((densityColors.length - 1) * totalComing / maxCapacity)

  if (gymOpen && gymOpen.exists && gymOpen.data() && gymOpen.data().status !== 'open') return <Box sx={{ mt: 4 }}><Alert severity="error">
        <AlertTitle>ห้องออกกำลังกายปิด</AlertTitle>
        โปรดรอเช็คอินหลังจากเจ้าหน้าที่เปิดแล้ว ขอบคุณครับ
      </Alert></Box>;
  return (
    <>
      <Helmet>
        <title> ARRIVAL BOARD </title>
      </Helmet>

      <Container maxWidth >


        <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} spacing={2}>

          {/* <Box
            display="flex"
            justifyContent="center"
            sx={{ mt: 12 }}
            >
            {videoPlayer}
            
          </Box> */}
          <Stack direction={'column'}>


            <Stack direction={{ sm: 'column', md: 'row' }} spacing={2} sx={{ mt: { xs: 4, sm: 6, md: 6, lg: 8 } }}>


              {info}
              <Paper elevation={8} sx={{
                p: 1, bgcolor: 'white',
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
              }} >
                <Box sx={{ textAlign: 'center', color: 'black', width: { md: '100%', lg: '24vw' } }} >
                  <Stack direction={'column'} spacing={1}>
                    <Typography variant="h5" gutterBottom>
                      ยอดรวมวันนี้
                    </Typography>
                    <div ref={totalRef} className="totalTickInfo" id="dots-size" >
                      <div data-repeat="true" aria-hidden="true">
                        <span data-view="flip" />
                      </div>
                    </div>
                    {/* <Typography variant="h4" gutterBottom sx={{ textAlign: 'center'}}>

                      </Typography>  */}
                    <Typography gutterBottom variant="h6">
                      The Runway Lab
                    </Typography>
                  </Stack>
                  {/* <Stack direction={'row'} spacing={4} >

                {tempInfoUi}

              </Stack> */}


                  {/* <Paper sx={{ p:1, m:1, mb: 1, bgcolor: 'DodgerBlue'}} >
                    <Typography variant="h5" sx={{ color: 'text.primary', m: 1 }}>
                    เช็คอินด้วย QR CODE
                  </Typography>
                  </Paper>
                  <Paper sx={{   m:1,  bgcolor: 'lightblue'}} >
                  <Typography variant="h6" sx={{ color: 'black', m: 1, mt:0 }}>
                    ใช้เมนูเช็คอินในไลน์
                  </Typography>

                  </Paper> */}



                </Box>


                {/* {CHECKINQR} */}
                {/* {`token ${JSON.stringify(token)}`} */}

                {/* <Box component="img"
                      src="/assets/L_gainfriends_2dbarcodes_BW.jpg"
                      sx={{ width: {xs: '100%', sm: '50%', md: 200},
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    mb: 2}}
                  />
                   */}

              </Paper>

              <CourseInfo />




              {/* <Stack direction='column' flex={{ sm: 1, md: 1}} sx={{ bgcolor: '#F00'}}>
                <Box sx={{ textAlign: 'center' }}>
                <Typography gutterBottom variant="h6">
                  The Runway Lab
                </Typography>

                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Add friend : scan QR Code
                </Typography>
              </Box>
              <Box component="img"
                    src="/assets/2dbarcodes_BW/L_gainfriends_2dbarcodes_BW.png"
                    sx={{ width: 200 }}
                />
          </Stack> */}



            </Stack>


            <Stack direction={{ sm: 'column', md: 'row' }} spacing={4} >
              {/* sx={{ mt:{ xs: 2, sm: 2, md:4, lg:4}   }} */}

              <Stack direction={'row'} spacing={4} sx={{ mt: 4 }}>
                <InfoPaper title={'ความหนาแน่น'} number={totalDensity} bgcolor={densityColors[denseColor] || "#000"} />
                <InfoPaper title={'กำลังมา'} number={totalComing} bgcolor={densityColors[queueColor] || "#000"} />
              </Stack>
              <Box sx={{ width: '100%' }}>
                {userstreemap}
              </Box>
              {/* { (token && newTrackCountdown >= 0)
          ? <>{trackinfo}</>
          : <SpotifyLogin /> } */}


            </Stack>


            <Stack direction={{ sm: 'column', md: 'row' }} sx={{ mt: 2 }} spacing={2} >

              {(token && newTrackCountdown >= 0)
                ? <>{trackinfo}</>
                : <SpotifyLogin />}

            </Stack>

          </Stack>

        </Stack>




        {/* {track && JSON.stringify(track)} */}

      </Container>
      {/* {CheckinDialog} */}
    </>
  );
}
